__turbopack_context__.v({
  "imageContainer": "jpXiAq_imageContainer",
  "left": "jpXiAq_left",
  "right": "jpXiAq_right",
  "textContainer": "jpXiAq_textContainer",
});
